import { NgClass, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'curbnturf-trailer-svg-line',
  templateUrl: './trailer-svg-line.component.html',
  styleUrls: ['./trailer-svg-line.component.scss'],
  standalone: true,
  imports: [NgClass, NgIf],
})
export class TrailerSvgLineComponent {
  @Input() type: string = 'classA';
  @Input() opacity = 1;
  @Input() secondary = false;
}
